export enum AcknowledgementType {
    ACCEPTED = 'Accepted',
    DECLINED = 'Declined',
    SKIPPED = 'Skipped'
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/acknowledgementType.enum.ts